module.exports = __webpack_public_path__ + "34bc775d/img/splash-icon.07a7c465.svg";